import {
  REPEATED_RESPONSE,
  QUOTA_EXCEEDED,
  MAX_RESPONSES,
  ONLY_DESKTOP,
  ONLY_MOBILE,
  DATA_QUALITY_ERROR,
  SURVEY_IS_PAUSED_AND_HAS_OVER_QUOTA_LINK,
  SURVEY_NOT_AVAILABLE,
} from '../../services/constants/backendErrorCodes';
import * as activeProjectTypes from './types/activeProject';

import { showNotification } from './notifications';
import { isTextEntry, isNPS } from '../../components/utils/helpers';
import { isNetquestClient } from '../../utils/platform';

export const handleResponseErrors = (response) => (dispatch, getState) => {
  const {
    activeProject: { translations: { data: translationsData = {} } = { data: {} } },
    capture: { selectedLanguage },
  } = getState();
  const { uiTags = {} } = translationsData[selectedLanguage] || {};
  const { status, data: { type, data: { redirectTo } = {} } = {} } = response;
  let errorMessage = uiTags.genericErrorMessage;

  if (status === 404) {
    const shouldRedirectForNetquest = isNetquestClient() && SURVEY_NOT_AVAILABLE === type;
    if (SURVEY_IS_PAUSED_AND_HAS_OVER_QUOTA_LINK === type || shouldRedirectForNetquest) {
      return dispatch(redirectSurvey({ redirectTo, type }));
    }
  }

  if (status === 409) {
    if (type === QUOTA_EXCEEDED) {
      return dispatch(redirectSurvey({ redirectTo, type }));
    }

    if (type === REPEATED_RESPONSE) {
      return dispatch(redirectSurvey({}));
    }

    if (type === DATA_QUALITY_ERROR) {
      return dispatch(redirectSurvey({ redirectTo, type }));
    }

    if (type === MAX_RESPONSES) {
      window.location.href = 'closed';
      return dispatch({
        type: activeProjectTypes.SCREEN_OUT_SURVEY,
      });
    }

    if (type === ONLY_MOBILE) {
      window.location.href = 'only-mobile';
      return dispatch({
        type: activeProjectTypes.SCREEN_OUT_SURVEY,
      });
    }

    if (type === ONLY_DESKTOP) {
      window.location.href = 'only-desktop';
      return dispatch({
        type: activeProjectTypes.SCREEN_OUT_SURVEY,
      });
    }

    if (type === DATA_QUALITY_ERROR) {
      return dispatch(redirectSurvey({ redirectTo, dqaError }));
    }
  }

  if (status === 422) {
    errorMessage = uiTags.answersErrorMessage;
  }

  if (status === 404) {
    dispatch(setCampaignWithErrors());
  }

  dispatch(showNotification({ message: errorMessage, level: 'error' }));
};

export const setCampaignWithErrors = () => {
  return {
    type: activeProjectTypes.SET_CAMPAIGN_HAS_ERRORS,
  };
};
export const redirectSurvey = ({ redirectTo, type }, fallbackActionForPreview) => (dispatch, getState) => {
  const { activeProject: { survey: { isPreview, isTest } = {} } = {} } = getState();

  if (isPreview || isTest) {
    let message = 'Selecting that option will disqualify user from survey';
    if (type === QUOTA_EXCEEDED) {
      message = 'That option does not have any quota remaining';
    }
    dispatch(showNotification({ message, level: 'warning' }));
    return dispatch({ type: fallbackActionForPreview || activeProjectTypes.SCREEN_OUT_SURVEY });
  }

  if (!redirectTo) {
    if (type === DATA_QUALITY_ERROR) {
      window.location.href = 'disqualified';
    } else if (type === QUOTA_EXCEEDED) {
      window.location.href = 'over-quota';
    } else {
      window.location.href = 'not-available';
    }
  } else {
    window.location = redirectTo;
  }

  return dispatch({
    type: activeProjectTypes.SCREEN_OUT_SURVEY,
  });
};

export const getScreenSize = () => {
  const screenWidth = Math.trunc(window.screen.width * window.devicePixelRatio);
  const screenHeight = Math.trunc(window.screen.height * window.devicePixelRatio);
  return {
    screenWidth,
    screenHeight,
  };
};
